import { Link } from "react-router-dom";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import Header from "../components/Header";
import backgroundImage from "../img/banner/ZTO-Banner.png";
import "../css/Instruction.css";
import CTASection from "../components/CTASection";

const Instruction = () => {
  const instructions = [
    {
      id: 1,
      title: "Lên đơn nhanh chóng cùng ZTO chỉ với 5 bước",
      videoId: "3-BiGYkb_F8",
      description:
        "Đơn giản hóa vận chuyển, đồng hành cùng mọi hành trình kinh doanh của bạn. ",
    },
    {
      id: 2,
      title: "Hướng dẫn lên đơn chính ngạch",
      videoId: "TeoPp2yVRp4",
      description:
        "Hỗ trợ bạn nhập hàng chính ngạch CHUYÊN NGHIỆP - ĐƠN GIẢN - RÕ RÀNG ",
    },
    {
      id: 3,
      title: "Hướng dẫn quản lý đơn (line TMĐT)",
      videoId: "0z1QQaxMfWM",
      description:
        "Sẵn sàng đồng hành, mang đến trải nghiệm vận chuyển chuyên nghiệp, minh bạch và an toàn cho bạn!",
    },
    {
      id: 4,
      title: "Hướng dẫn quản lý đơn chính ngạch (Line VAT)",
      videoId: "bJ9wH86rDQw",
      description:
        "Quản lý đơn hàng chính ngạch giờ đây không còn phức tạp. Với Line VAT tại ZTO Việt Nam, doanh nghiệp dễ dàng:",
    },
    {
      id: 5,
      title: "Hướng dẫn lên đơn hàng loạt",
      videoId: "PeoII2KQCgs",
      description: "Hướng dẫn lên đơn hàng loạt",
    },
  ];

  const handleCardClick = (videoId) => {
    window.open(`https://www.youtube.com/watch?v=${videoId}`, "_blank");
  };

  return (
    <div className="instruction-section">
      <Header />
      <Banner
        title="Hướng dẫn"
        backgroundImage={backgroundImage}
        breadcrumb={
          <>
            <Link to={"/"} className="text-white p-2">
              Trang chủ
            </Link>
            <span>{">"}</span>
            <Link to={"/instruction"} className="text-white p-2">
              Hướng dẫn
            </Link>
          </>
        }
      />
      <div className="container my-5">
        <div className="instruction-header text-center mb-5">
          <h2>Video Hướng dẫn</h2>
          <div className="instruction-subtitle">
            <p>Xem các video hướng dẫn chi tiết để sử dụng dịch vụ hiệu quả</p>
          </div>
        </div>

        <div className="instruction-grid">
          {instructions.map((instruction) => (
            <div
              key={instruction.id}
              className="instruction-card"
              onClick={() => handleCardClick(instruction.videoId)}
            >
              <div className="instruction-video-wrapper">
                <iframe
                  width="100%"
                  height="220"
                  src={`https://www.youtube.com/embed/${instruction.videoId}`}
                  title={instruction.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="instruction-iframe"
                ></iframe>
                <div className="video-overlay">
                  <i className="fas fa-play-circle"></i>
                </div>
              </div>
              <div className="instruction-content">
                <h3 className="instruction-title">{instruction.title}</h3>
                <a
                  href={`https://www.youtube.com/watch?v=${instruction.videoId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="view-video-btn"
                >
                  Xem trên YouTube <i className="fas fa-external-link-alt"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
      <CTASection />
      <Footer />
    </div>
  );
};

export default Instruction;
